import React, { useState, useEffect, useRef } from "react";
import logo from '../../images/vanani_logo.svg';
import { Link, useLocation, useNavigate } from "react-router-dom";
import Button from '../Button';

function Navbar() {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const dropdownRef = useRef(null);

  const location = useLocation();
  const navigate = useNavigate();

  const toggleDropdown = (e, key) => {
    // Prevent default anchor action if needed, or rely on Link
    // If it's a link, we might want to navigate AND toggle, or just toggle for submenu items
    // For the main "Services" link, if it has a submenu, mobile usually requires a click to open submenu
    if (window.innerWidth < 992) {
      e.preventDefault();
      setActiveDropdown((prev) => (prev === key ? null : key));
    }
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeDropdown = () => {
    setActiveDropdown(null);
  };

  const handleScroll = (e) => {
    e.preventDefault();
    const targetId = e.target.getAttribute("href").slice(1);
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
    setMobileMenuOpen(false); // Close menu on scroll link click
  };

  const handleLogoClick = () => {
    if (location.pathname === "/") {
      window.scrollTo(0, 0);
    } else {
      navigate("/");
    }
    setMobileMenuOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        closeDropdown();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
    setActiveDropdown(null);
  }, [location]);

  return (
    <div className="header_main_wrap">
      <div className="container">
        <div className="inr_header_wrap row align-items-center justify-content-between">
          <div className="col-8 col-lg-3 col-md-3">
            <img
              src={logo}
              alt="Vanani Associated"
              onClick={handleLogoClick}
              style={{ cursor: 'pointer' }}
            />
          </div>
          <div className="col-4 col-lg-9 col-md-9 text-end">
            <div className="mobile_toggle_btn d-lg-none d-block" onClick={toggleMobileMenu}>
              <i className={mobileMenuOpen ? "fas fa-times" : "fas fa-bars"}></i>
            </div>
            <div className={`nav_wrapper d-flex justify-content-end align-items-center ${mobileMenuOpen ? 'mobile_open' : ''}`}>
              <ul className="d-flex justify-content-end">
                <li><Link to="/about">About Us</Link></li>
                <li
                  ref={dropdownRef}
                  className={`dropdown ${activeDropdown === 'services' ? "active" : ""}`}
                >
                  <Link to="/Services" onClick={(e) => toggleDropdown(e, 'services')}>
                    Services <i className="fas fa-chevron-down"></i>
                  </Link>
                  <ul className={`first_drop_down ${activeDropdown === 'services' ? "d-block" : ""}`}>
                    <li><Link to="/incorporation">Incorporation</Link> <i class="fas fa-chevron-right"></i>
                      <ul className='second_drop_down'>
                        <li><Link to="/sole-proprietorship">Sole Proprietorship</Link></li>
                        <li><Link to="/partnership-firm">Partnership Firm</Link></li>
                        <li><Link to="/limited-liability">Limited Liability Partnership (LLP)</Link></li>
                        <li><Link to="/one-person-company">One Person Company</Link></li>
                        <li><Link to="/private-limited-company">Private Limited Company</Link></li>
                        <li><Link to="/public-limited-company">Public Limited Company</Link></li>
                      </ul>
                    </li>
                    <li><Link to="/accounting">Accounting</Link></li>
                    <li><Link to="/Taxation">Taxation</Link><i class="fas fa-chevron-right"></i>
                      <ul className='second_drop_down'>
                        <li><Link to="/direct-tax-services">Direct Tax Services</Link></li>
                        <li><Link to="/indirect-tax-service">Indirect Tax Service</Link></li>
                      </ul>
                    </li>
                    <li><Link to="/specialized_tax-services">Specialized Tax Services</Link></li>
                    <li><Link to="/audit-and-assurance-services">Audit & Assurance</Link></li>
                    <li><Link to="/consultancy-services">Consultancy Service</Link></li>
                    <li><Link to="/">Corporate Compliance</Link></li>
                    <li><Link to="/">CFO Services</Link></li>
                    <li><Link to="/">Outsourcing</Link></li>
                  </ul>
                </li>
                <li className={`dropdown ${activeDropdown === 'industries' ? "active" : ""}`}>
                  <Link to="/" onClick={(e) => toggleDropdown(e, 'industries')}>
                    Industries <i className="fas fa-chevron-down"></i>
                  </Link>
                  <ul className={`first_drop_down ${activeDropdown === 'industries' ? "d-block" : ""}`}>
                    <li><Link to="/">Real Estate & Infrastructure</Link></li>
                    <li><Link to="/">Manufacturing</Link></li>
                    <li><Link to="/">Taxtile</Link></li>
                    <li><Link to="/">Engineering & Consultancy</Link></li>
                  </ul>
                </li>
                <li><Link to="/">Query</Link></li>
                <li><Link to="/">Careers</Link></li>
                <li><Link to="/Blogs">Blogs</Link></li>
              </ul>
              <div className="right_btn_Wrap">
                <Button to="/#contact-us-wrapper" onClick={() => setMobileMenuOpen(false)}>
                  Contact Us
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

export default Navbar;
